const navGroup = [
  { label: "今日更新", href: "#updates" },
  { label: "热播剧榜", href: "#series" },
  { label: "电影推荐", href: "#movies" },
  { label: "蓝光画质", href: "#bluray" },
];

const navGroup2 = [
  { label: "高分片单", href: "#playlists" },
  { label: "全网资源库", href: "#library" },
  { label: "找片指南", href: "#guide" },
  { label: "常见问题", href: "#faq" },
];

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-50">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50/15">
                <i className="ri-film-line text-lg text-primary-300"></i>
              </span>
              <span className="font-heading text-lg font-semibold">茶杯狐影视</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-100/70">
              一个把热播剧、电影推荐、蓝光画质资源与高分片单整理到一起的选片页面。
              我们只做信息聚合与分类，帮助你在开看之前更快找到方向。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {["热播剧跟播", "电影口碑推荐", "蓝光画质档位", "高分场景片单"].map((t) => (
                <span
                  key={t}
                  className="rounded-full border border-background-50/20 px-3 py-1 text-xs text-background-100/80"
                >
                  {t}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-primary-300">内容分区</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {navGroup.map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className="text-sm text-background-100/70 transition-colors hover:text-background-50 cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-primary-300">找片与帮助</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {navGroup2.map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className="text-sm text-background-100/70 transition-colors hover:text-background-50 cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 rounded-lg border border-background-50/15 bg-background-50/5 px-5 py-4">
          <p className="text-xs leading-relaxed text-background-100/60">
            免责声明：本站为影视信息聚合与推荐页面，仅提供片名、简介、评分参考与画质档位等文字信息，
            不存储、不制作也不提供任何音视频文件。页面中的评分为横向比较用的参考值，不作为官方结论；
            作品版权归原权利人所有，观看时请选择正规授权渠道。
          </p>
        </div>

        <div className="mt-8 flex flex-col gap-3 border-t border-background-50/15 pt-6 text-xs text-background-100/55 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 茶杯狐影视 · 内容仅供选片参考</p>
          <p className="flex items-center gap-2">
            <i className="ri-shield-check-line"></i>
            信息聚合页面 · 不提供资源下载
          </p>
        </div>
      </div>
    </footer>
  );
}